import { useCallback, useEffect, useState } from "react";
import {
  Box,
  HStack,
  Image,
  Modal,
  Pressable,
  Spinner,
  Text,
  VStack,
  View,
  useMediaQuery,
} from "native-base";
import FileUploader from "../../../../containers/fileUpload";
import { COLORS } from "../../../../utils/colors";
import ViewUploadImageCards from "../../../../containers/viewUploadImageCards";
import VideoViewer from "../../../../components/videoViewer";
import { MOBILE_VIEW_WIDTH } from "../../../../utils/screens";
import { Toaster } from "../../../../components/toaster";
import { hasPermission, statusMap } from "../../../../utils/permission";
import ContainerCards from "../../../../components/cards";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import { noPhotosUploadedSVG, uploadIconSVG } from "../../../../utils/svg";
import CustomButton from "../../../../components/button";
import CommonHeading from "../../../../components/headings";
import ImageViewer from "../../../../components/imageViewer";
import { isVideoByExtension } from "../../../../utils/fileUtils";

export const UploadNewPhoto = ({
  uploadImageFiles,
  setUploadImageFiles,
  uploadImages,
  setUploadImages,
  forceRemount = false
}) => {
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowVideoModal(true);
    // Scroll to top when video modal opens
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo("");
  };
  const toaster = Toaster();

  const handleImageChange = (files) => {
    // if (files.length > 20) {
    //   toaster("Maximum 20 images allowed", "error", "error");
    //   return;
    // }
    setUploadImageFiles(files);
    const mediaUrls = Array.from(files).map((file) =>
      URL.createObjectURL(file)
    );
    setUploadImages(mediaUrls);
  };

  const onDeleteImage = (ind) => {
    let file = [...uploadImageFiles];
    let media = [...uploadImages];
    file.splice(ind, 1);
    media.splice(ind, 1);
    setUploadImageFiles(file);
    setUploadImages(media);
  };

  return (
    <VStack>
      <Box pb={2}>
        {/* <Text
          fontSize={"18px"}
          fontWeight={"600"}
          color={COLORS.ACCORDION_TITLE_COLOR}
        >
          Upload Photo
        </Text> */}
        <FileUploader
          multiple
          files={uploadImageFiles}
          show={false}
          setFiles={handleImageChange}
          accept={["png", "jpg", "jpeg", "mp4", "mov", "avi", "mkv", "webm"]}
          types=".png, .jpg, .jpeg, .mp4, .mov, .avi, .mkv, .webm"
          images={true}
          forceRemount={forceRemount}
        />
      </Box>
      <HStack flex={1} flexWrap={"wrap"}>
        {uploadImages &&
          uploadImages.map((item, ind) => {
            const file = uploadImageFiles[ind];
            const isVideo = file && isVideoByExtension(file);
            
            return isVideo ? (
              <VideoViewer
                key={ind}
                ind={ind}
                url={item}
                onDeleteVideo={onDeleteImage}
                onVideoClick={handleVideoClick}
              />
            ) : (
              <ViewUploadImageCards
                key={ind}
                ind={ind}
                url={item}
                onDeleteImage={onDeleteImage}
              />
            );
          })}
      </HStack>
      {showVideoModal && (
        <VideoDisplayFullScreen
          selectedVideo={selectedVideo}
          setSelectedVideo={setSelectedVideo}
          closeModal={closeVideoModal}
          h="90%"
        />
      )}
    </VStack>
  );
};

export const RequestDetailsPhotoListing = ({
  images,
  setShowButtons,
  showButtons,
  openPhotoModal,
  scrollToTop = () => {},
  isLoading = true,
  eventsDetail,
  onImagesDeleted = () => {},
}) => {
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowVideoModal(true);
    // Scroll to top when video modal opens
    scrollToTop();
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo("");
  };
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const [selectedImagePath, setSelectedImagePath] = useState("");
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    scrollToTop();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleImages = (index, path) => {
    setSelectedImagePath(path);
    openModal();
  };

  const noPhotoUploaded = () => {
    return (
      <ContainerCards
        background={COLORS.WHITE_COLOR}
        boxShadow="0px 18.953px 47.382px 0px rgba(119, 115, 170, 0.10)"
        height="auto"
        width="100%"
      >
        <Box p={6} w={"100%"}>
          <CommonHeading text="Media" />
          <VStack alignItems={"center"} space={4}>
            {noPhotosUploadedSVG}
            <Box alignItems={"center"}>
              {/* <Text
                fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
                color={COLORS.ACCORDION_TITLE_COLOR}
              >
                Empty
              </Text> */}
              <Text
                fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                color={COLORS.BLACK_COLOR}
              >
                No media available
              </Text>
            </Box>
            {statusMap?.indexOf(eventsDetail?.status) >= 2 && (
              <CustomButton
                endIcon={uploadIconSVG}
                bgColor={COLORS.UPLOAD_BUTTON_COLOR}
                borderRadius="50px"
                text={"Upload Photo/Video"}
                textColor={COLORS.BLACK_COLOR}
                fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                width="auto"
                py={2}
                onPress={openPhotoModal}
              />
            )}
          </VStack>
        </Box>
      </ContainerCards>
    );
  };

  const getImages = () => {
    const filteredAndMappedImages = images[0]?.approved_images?.filter(
      (source) =>
        hasPermission("REVIEW_LIST") ||
        (!hasPermission("REVIEW_LIST") && source.status === "image_approved")
    );
    if (filteredAndMappedImages && filteredAndMappedImages.length > 0)
      setShowButtons(true);
    return filteredAndMappedImages;
  };

  return (
    <HStack mt={showButtons && 3} flex={1} w={"100%"} display={'flex'} flexDirection={'column'}>
      {images.length > 0 && (
        <ImageViewer 
          path 
          images={getImages()} 
          showSelectAll={true}
          showUploadedBy={true}
          onImagesDeleted={onImagesDeleted}
          onVideoClick={handleVideoClick}
        />
      )}
      {isLoading && (
        <>
          <CommonHeading text="Media" />
          <Box
            mt={"100px"}
            mx={MobileWindow && 10}
            flex={!MobileWindow && 1}
            alignItems="center"
            justifyContent="center"
          >
            <Spinner color={COLORS.THEME_COLOR} size="lg" />
          </Box>
        </>
      )}
      {!showButtons && !isLoading && images.length === 0 && noPhotoUploaded()}
      {showModal && (
        <PhotoDisplayFullScreen
          selectedImage={selectedImagePath}
          setSelectedImage={setSelectedImagePath}
          closeModal={closeModal}
        />
      )}
      {showVideoModal && (
        <VideoDisplayFullScreen
          selectedVideo={selectedVideo}
          setSelectedVideo={setSelectedVideo}
          closeModal={closeVideoModal}
          h="90%"
        />
      )}
    </HStack>
  );
};

export const PhotoDisplayFullScreen = ({
  selectedImage = "",
  setSelectedImage = () => {},
  closeModal = () => {},
  w = "100%",
  h = "100%",
}) => {
  const handleClose = () => {
    setSelectedImage(null);
    closeModal();
  };

  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });

  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const getImageSize = useCallback(async () => {
    if (selectedImage) {
      try {
        const { width, height } = await new Promise((resolve, reject) => {
          Image.getSize(
            selectedImage,
            (width, height) => resolve({ width, height }),
            (error) => reject(error)
          );
        });

        setImageDimensions({ width, height });
      } catch (error) {
        console.error("Error getting image size:", error);
      }
    }
  }, [selectedImage]);

  useEffect(() => {
    getImageSize();
    if (selectedImage) {
      document.body.classList.add("modal-open-1");
    } else {
      document.body.classList.remove("modal-open-1");
    }
    return () => {
      document.body.classList.remove("modal-open-1");
    };
  }, [getImageSize]);

  const modalContentStyle = {
    flex: 1,
  };
  
  const fullScreenImageStyle = {
    resizeMode: "contain",
    width: "100%",
    height: MobileWindow
      ? imageDimensions.height <= 900
        ? "100%"
        : "30%"
      : "100%",
  };

  return (
    <View top={0} width={"100%"}>
      {selectedImage && (
        <Modal
          isOpen
          onClose={handleClose}
          marginTop={!MobileWindow && "10px"}
          justifyContent={"start"}
          background={MobileWindow && "rgba(250, 249, 246, 0.91)"}
        >
          <Modal.Content
            bg={"none"}
            style={{ boxShadow: "none" }}
            // top={MobileWindow && "25%"}
            // maxW={ imageDimensions.width > 900 && imageDimensions.width < 4000
            //     ? imageDimensions.width - 500
            //     : imageDimensions.width
            // }
            // minH={ imageDimensions.height > 500 && imageDimensions.height < 3000
            //     ? imageDimensions.height - 300
            //     : imageDimensions.height
            // }
            // maxH={imageDimensions.height - 500}
            // w={MobileWindow ? w : imageDimensions.width}
            // h={MobileWindow ? imageDimensions.height : imageDimensions.height}
            maxW={
              MobileWindow
                ? "auto"
                : imageDimensions.width > 900 && imageDimensions.width < 2000
                ? imageDimensions.width - 500
                : imageDimensions.width >= 2000 && imageDimensions.width <= 4000
                ? imageDimensions.width - imageDimensions.width / 1.2
                : imageDimensions.width <= 900
                ? imageDimensions.width
                : imageDimensions.width > 7000
                ? imageDimensions.width - imageDimensions.width / 1.1
                : imageDimensions.width - imageDimensions.width / 1.3
            }
            minH={
              MobileWindow
                ? "auto"
                : imageDimensions.height > 500 && imageDimensions.height < 2000
                ? imageDimensions.height - 300
                : imageDimensions.height >= 2000 &&
                  imageDimensions.height < 4000
                ? imageDimensions.height - imageDimensions.height / 1.23
                : imageDimensions.height <= 500
                ? imageDimensions.height
                : imageDimensions.height - imageDimensions.height / 1.1
            }
            maxH={imageDimensions.height - 500}
            w={
              MobileWindow
                ? w
                : imageDimensions.width > 900 && imageDimensions.width < 2000
                ? imageDimensions.width - 500
                : imageDimensions.width >= 2000 && imageDimensions.width <= 4000
                ? imageDimensions.width - imageDimensions.width / 1.2
                : imageDimensions.width <= 900
                ? imageDimensions.width
                : imageDimensions.width > 7000
                ? imageDimensions.width - imageDimensions.width / 1.1
                : imageDimensions.width - imageDimensions.width / 1.3
            }
            h={
              MobileWindow
                ? h
                : imageDimensions.height > 500 && imageDimensions.height < 2000
                ? imageDimensions.height - 300
                : imageDimensions.height >= 2000 &&
                  imageDimensions.height < 4300
                ? imageDimensions.height - imageDimensions.height / 1.22
                : imageDimensions.height >= 4300 &&
                  imageDimensions.height < 6000
                ? imageDimensions.height - imageDimensions.height / 1.19
                : imageDimensions.height <= 500
                ? imageDimensions.height
                : imageDimensions.height - imageDimensions.height / 1.1
            }
          >
            <Modal.CloseButton
              style={{
                background: "white",
                width: "30px",
                height: "30px",
              }}
            />
            <Box style={modalContentStyle}>
              <Image
                source={{ uri: selectedImage }}
                style={fullScreenImageStyle}
                alt="image"
                resizeMode={
                  MobileWindow
                    ? "contain"
                    : imageDimensions.width > 6000
                    ? "contain"
                    : "stretch"
                }
              />
            </Box>
          </Modal.Content>
        </Modal>
      )}
    </View>
  );
};

export const VideoDisplayFullScreen = ({
  selectedVideo = "",
  setSelectedVideo = () => {},
  closeModal = () => {},
  w = "100%",
  h = "100%",
}) => {
  const handleClose = () => {
    setSelectedVideo(null);
    closeModal();
  };

  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  useEffect(() => {
    if (selectedVideo) {
      document.body.classList.add("modal-open-1");
      // Scroll to top when video modal opens
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      document.body.classList.remove("modal-open-1");
    }
    return () => {
      document.body.classList.remove("modal-open-1");
    };
  }, [selectedVideo]);

  const modalContentStyle = {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  
  const fullScreenVideoStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    maxWidth: "100%",
    maxHeight: "100%",
  };

  return (
    <View top={0} width={"100%"}>
      {selectedVideo && (
        <Modal
          isOpen
          onClose={handleClose}
          marginTop={!MobileWindow && "10px"}
          justifyContent={"start"}
          background={MobileWindow && "rgba(250, 249, 246, 0.91)"}
        >
          <Modal.Content
            bg={"none"}
            style={{ boxShadow: "none" }}
            maxW={MobileWindow ? "auto" : "90vw"}
            minH={MobileWindow ? "auto" : "70vh"}
            maxH={MobileWindow ? "auto" : "90vh"}
            w={MobileWindow ? w : "90vw"}
            h={MobileWindow ? h : "80vh"}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Modal.CloseButton
              style={{
                background: "white",
                width: "30px",
                height: "30px",
              }}
            />
            <Box style={modalContentStyle}>
              <video
                src={selectedVideo}
                style={fullScreenVideoStyle}
                controls
                autoPlay
                muted={false}
              >
                Your browser does not support the video tag.
              </video>
            </Box>
          </Modal.Content>
        </Modal>
      )}
    </View>
  );
};
